export const TitleSizeOptions = [
  {
    label: "S",
    value: 32,
  },
  {
    label: "M",
    value: 40,
  },
  {
    label: "L",
    value: 48,
  },
];

export const TextSizeOptions = [
  {
    label: "S",
    value: 16,
  },
  {
    label: "M",
    value: 18,
  },
  {
    label: "L",
    value: 22,
  },
];

export const OverlineSizeOptions = [
  {
    label: "S",
    value: 16,
  },
  {
    label: "M",
    value: 18,
  },
  {
    label: "L",
    value: 22,
  },
];

export const IconSizeOptions = [
  {
    label: "S",
    value: 32,
  },
  {
    label: "M",
    value: 40,
  },
  {
    label: "L",
    value: 48,
  },
];

export const LineWidthOptions = [
  {
    label: "S",
    value: 10,
  },
  {
    label: "M",
    value: 15,
  },
  {
    label: "L",
    value: 20,
  },
];

export const LineWeightOptions = [
  {
    label: "S",
    value: 1,
  },
  {
    label: "M",
    value: 2,
  },
  {
    label: "L",
    value: 3,
  },
];
